import React from "react";
import { HashLink as Link } from 'react-router-hash-link';
import { Button } from "semantic-ui-react";
import { useStore } from "../../app/stores/store";
// import "../Certificacion/Curso.css";

interface Props {
    codigo: any;
    arancel: any;
}

export default function PagoModalConvenio(props: Props) {
    const {userStore: {user}, modalStore} = useStore();
    return(

        <>

            <div className="modal_pago_cur">
                <div className="modal_pago_head">
                    <h1>Tu Inscripción ha sido realizada con éxito.</h1>
                </div>
                
                <div className="contenido_modal_pago">
                    <p>El monto de la inversión que correspondiente al servicio académico, será cancelado por tu institución.</p>

                    <div className="botones_pago_modal">
                        <Button color="blue" onClick={() => {
                            modalStore.closeModal()
                            }}>Cerrar
                        </Button>
                    </div>
                </div>
                
            </div>

        </>

    )
}